import Vue from "vue";

const state = {
  products: []
};
const actions = {
  getProducts({ commit }, { next_page_url, category }) {
    let url = next_page_url || "/api/webshop/products/v1";
    let config = {};
    if (category !== null) {
      config = {
        params: {
          category: category
        }
      };
    }
    return Vue.prototype.$http.get(url, config);
  },
  getCategories() {
    return Vue.prototype.$http.get("/api/webshop/categories/v1");
  }
};
const mutations = {};
const getters = {
  products: state => {
    return state.products;
  }
};

export const product = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
